import React from 'react'
import IMG from "./angular.png"
function Angular() {
  return (
    <img src={IMG} style={{width:"200px",height:"150px" }} alt='angular' />
  )
}

export default Angular